import React, { useEffect } from 'react';
import { GENRE_KEYS, Genres } from '@soundxyz/utils/const';
import { useSingleLocationSelect } from '@components/Location/select';
import { Item, Select } from '@components/basics/forms/inputs/Select';
import { ParamsStore, useParams } from '@context/params';
import { ReleaseStatus } from '@graphql/reactQuery';
import { AVAILABILITY } from './constants';

export const Filters = ({
  showAvailabilityFilter,
  showLocationFilter,
  showGenreFilter,
}: {
  showAvailabilityFilter: boolean;
  showLocationFilter: boolean;
  showGenreFilter: boolean;
}) => {
  const { search_availability, genre } = useParams();

  const initialLocation = (() => {
    if (ParamsStore.search_location_label && ParamsStore.search_location_place_id) {
      return {
        label: ParamsStore.search_location_label,
        placeId: ParamsStore.search_location_place_id,
      };
    }
    return null;
  })();

  const { locationSelect, locationValue } = useSingleLocationSelect({
    initialLocation: initialLocation,
    placeholder: 'Location',
    setIsKeyboardOpen: null,
    onLocationChange: value => {
      if (value) {
        ParamsStore.search_location_label = value.label;
        ParamsStore.search_location_place_id = value.value.place_id;
      } else {
        ParamsStore.search_location_label = null;
        ParamsStore.search_location_place_id = null;
      }
    },
  });

  useEffect(() => {
    if (!locationValue) {
      ParamsStore.search_location_label = null;
      ParamsStore.search_location_place_id = null;
      return;
    }
    ParamsStore.search_location_label = locationValue.label;
    ParamsStore.search_location_place_id = locationValue.value.place_id;
  }, [locationValue]);

  return (
    <div className="mb-1 flex gap-4">
      {showAvailabilityFilter && (
        <div className="w-[140px]">
          <Select
            value={search_availability || ''}
            onValueChange={availability => {
              if (availability) {
                return (ParamsStore.search_availability = availability);
              }
              return (ParamsStore.search_availability = null);
            }}
            placeholder="Availability"
          >
            {Object.values(ReleaseStatus).map(value => {
              return (
                <Item key={value} value={value}>
                  {AVAILABILITY[value]}
                </Item>
              );
            })}
          </Select>
        </div>
      )}
      {showLocationFilter && (
        // child select div and set width to 100% to make it responsive
        <div className="w-[220px] rounded-[6px] bg-base200 [&>*]:h-full [&>*]:w-full">
          {locationSelect}
        </div>
      )}
      {showGenreFilter && (
        <div className="w-[220px]">
          <Select
            value={genre || ''}
            onValueChange={genre => {
              if (genre) {
                return (ParamsStore.genre = genre);
              }
              return (ParamsStore.genre = null);
            }}
            placeholder="Genre"
            contentClassName="h-48"
          >
            {GENRE_KEYS.map(value => {
              return (
                <Item key={value} value={value}>
                  {Genres[value]}
                </Item>
              );
            })}
          </Select>
        </div>
      )}
    </div>
  );
};
